import styled from 'styled-components'

export const SecondaryInfo = styled.div<TSFixMe>`
  font-size: 13px;
  color: #9999bd;
  white-space: nowrap;
`
